<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>

<form
  name="accountForm"
  #accountForm="ngForm"
  *ngIf="cardholderDetails"
  novalidate
>
  <div>
    <div class="sync" *ngIf="hasEntitlements('CARDHOLDERS_ACCOUNTS_SYNC')">
      <app-confirm-button-combo
        [addSpacer]="false"
        [baseLabel]="' SYNC '"
        (confirmSelected)="syncProfile()"
      >
      </app-confirm-button-combo>
    </div>
  </div>
  <!-- STRIP ACCOUNT begin -->
  <div
    class="card card-nc"
    *ngIf="hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP')"
  >
    <!-- Default card contents -->
    <div class="card-heading">
      <i class="fa fa-credit-card"></i>
      <span class="cardHeaderHeading"> STRIP ACCOUNT: </span>
      <span class="cardHeaderVal">{{ stripAccount.account }}</span>

      <ng-container *ngIf="identity && identity.dda">
        <span style="padding-left: 40px" class="cardHeaderHeading">
          Pseudo DDA: </span
        >&nbsp;&nbsp;
        <span class="cardHeaderVal">{{ identity.dda }}</span>
      </ng-container>

      <span class="float-right save-card">
        <button
          type="button"
          [ngClass]="{ 'fa fa-spinner': save_s_btn }"
          *ngIf="
            hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') &&
            isEscrow == false
          "
          (click)="saveStripAccount()"
          class="btn btn-nc save-card-btn"
          [disabled]="!accountForm.valid"
        >
          SAVE
        </button>
      </span>

      <span class="float-right subCardHeaderHeading lastPwdLabelBox">
        <div class="col-md-12" style="padding-right: 20px">Last update on</div>

        <div class="col-md-12" style="padding-right: 20px">
          {{ stripAccount.statusDate | date: "fullDate" }}
        </div>
      </span>
    </div>

    <div class="card-body">
      <div class="row labelCommon text-nowrap">
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Account Balance</div>
          <div class="col-md-12">
            <span class="staticText1">
              <span class="dollerSymbolColor">
                <i class="fa fa-usd"></i>&nbsp; </span
              >{{ stripAccount.currentBalance | currency: "" : "" }}
            </span>
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Hold Amount</div>
          <div class="col-md-12">
            <span class="staticText1">
              <span class="dollerSymbolColor">
                <i class="fa fa-usd"></i>&nbsp; </span
              >{{ stripAccount.holdAmount | currency: "" : "" }}
            </span>
          </div>
        </div>
        <div class="col-md-2 zeroPadding accountBorder">
          <div class="col-md-12">ACH Withdrawal Limit</div>
          <div
            class="form-group col-md-12"
            *ngIf="
              hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') && !isEscrow
            "
          >
            <span class="staticText1">
              <span class="innerFieldSymbol">
                <i class="fa fa-usd"></i>
              </span>
              <input
                type="text"
                id="stripWithdrawalLimit"
                name="withdrawalLimit"
                style="width: 95%"
                [(ngModel)]="stripAccount.withdrawalLimit"
                maxlength="8"
                required
                class="form-control input-sm outerBox"
                #wdlLimit="ngModel"
                pattern="^\d*\.?\d{1,2}$"
            /></span>
            <span
              *ngIf="wdlLimit.touched && wdlLimit.dirty && !wdlLimit.valid"
              class="has-error validationMessage"
            >
              Invalid Amount
            </span>
          </div>
          <div
            class="form-group col-md-12 accountBorder"
            *ngIf="
              !hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') || isEscrow
            "
          >
            <span class="staticText1">
              <span class="dollerSymbolColor">
                <i class="fa fa-usd"></i>&nbsp;
              </span>
              {{ stripAccount.withdrawalLimit | currency: "" : "" }}
            </span>
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Creation Date</div>
          <div class="form-group col-md-12 staticText1">
            {{ stripAccount.openDate | date: "MM/dd/yyyy" }}
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12 control-label labelCommon">Status</div>
          </div>
          <div class="row">
            <div
              class="form-group col-md-10"
              *ngIf="
                hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') &&
                !isEscrow
              "
              style="margin-bottom: -20px"
            >
              <select
                class="form-control input-sm"
                [(ngModel)]="stripAccount.status"
                id="stripStatus"
                name="stripStatus"
              >
                <option
                  *ngFor="let stripStat of stripAccount.targetStats"
                  [value]="stripStat"
                >
                  {{ stripStat }}
                </option></select
              >&nbsp;&nbsp;
            </div>
          </div>
          <div
            class="form-group col-md-10 staticText1"
            *ngIf="
              !hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') || isEscrow
            "
          >
            {{ stripAccount.status }}
          </div>
          <div class="col-md-2 float-right" style="margin-top: -20px">
            <p [ngClass]="stripAccount.status | processingStatusPipe"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- STRIP ACCOUNT end -->
  <!-- Card ACCOUNT begin -->
  <div *ngIf="hasEntitlements('CARDHOLDERS_ACCOUNTS_CARDS')">
    <div
      class="card card-nc"
      *ngFor="let card of cardsAccount; let index = index"
    >
      <!-- Default card contents -->
      <div class="card-heading">
        <span class="icon-NC_chip"></span>
        <span class="cardHeaderHeading"> CARD ID: </span>
        <span class="cardHeaderVal">
          {{ card.cardSeq }}
          <span *ngIf="isEMV(card.closedLoopPan) == true">
            <img id="EMV-card" src="assets/img/EMV.svg" alt="" />
          </span>
        </span>
        <span class="pull-right save-card">
          &nbsp;&nbsp;
          <button
            *ngIf="
              (hasEntitlements('CARDHOLDERS_ACCOUNTS_CARD_UPDATE') ||
                hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIP_UPDATE')) &&
              isEscrow == false
            "
            type="button"
            [disabled]="spinnerFlag || !changedValue"
            [ngClass]="{ 'fa fa-spinner': save_a_btn }"
            (click)="saveAccounts(index)"
            class="btn btn-nc save-card-btn"
          >
            SAVE
          </button>
        </span>
      </div>
      <div class="card-body">
        <div class="row cardRowBackground labelCommon text-nowrap">
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Card Number</div>
            <div class="col-md-12 staticText1">*****{{ card.masterCard }}</div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Issue Date</div>
            <div class="col-md-12 staticText1">
              {{ card.issueDate | date: "MM/dd/yyyy" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Expiry Date</div>
            <div class="col-md-12 staticText1">
              {{ card.expirationDate | date: "MM/dd/yyyy" : "UTC" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Card Status Date</div>
            <div class="col-md-12 staticText1">
              {{ card.statusDate | date: "MM/dd/yyyy" }}
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <div class="col-md-12">Status</div>
            <div
              class="form-group col-md-10"
              *ngIf="
                (originalCardStatuses[index] == 'ACTIVE' ||
                  originalCardStatuses[index] == 'PENDACTIVE') &&
                hasEntitlements('CARDHOLDERS_ACCOUNTS_CARD_UPDATE') &&
                !isEscrow
              "
            >
              <select
                class="form-control input-sm"
                [(ngModel)]="cardsAccount[index].status"
                [name]="'cardStatus-' + index"
                [id]="'cardStatus-' + index"
                (ngModelChange)="
                  onChangeCard(cardsAccount[index].status, index)
                "
              >
                <option
                  *ngFor="let cardStat of card.targetStats"
                  [value]="cardStat"
                >
                  {{ cardStat }}
                </option>
              </select>
            </div>
            <div
              class="form-group col-md-10 staticText1"
              *ngIf="
                (originalCardStatuses[index] != 'ACTIVE' &&
                  originalCardStatuses[index] != 'PENDACTIVE') ||
                !hasEntitlements('CARDHOLDERS_ACCOUNTS_CARD_UPDATE') ||
                isEscrow
              "
            >
              {{ card.status }}
            </div>
            <div class="col-md-2 float-right" style="margin-top: -40px">
              <p [ngClass]="card.status | processingStatusPipe"></p>
            </div>
          </div>
        </div>
        <!-- CHIP ACCOUNT begin -->
        <div *ngIf="hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIPS')">
          <div class="row chipRowBackground labelCommon text-nowrap">
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Chip Number</div>
              <div class="col-md-12 staticText1">{{ card.chipAccount }}</div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Account Balance</div>
              <div class="col-md-12">
                <span class="staticText1">
                  <span class="dollerSymbolColor">
                    <i class="fa fa-usd"></i> </span
                  >&nbsp;{{
                    chipsAccount[index].currentBalance | currency: "" : ""
                  }}
                </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Open Date</div>
              <div class="col-md-12 staticText1">
                <span class="staticText1">
                  {{ chipsAccount[index].openDate | date: "MM/dd/yyyy" }}
                </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Chip Status Date</div>
              <div class="col-md-12 staticText1">
                {{ chipsAccount[index].statusDate | date: "MM/dd/yyyy" }}
              </div>
            </div>
            <div class="col-md-4 zeroPadding">
              <div class="col-md-12">Status</div>
              <div
                class="form-group col-md-10"
                *ngIf="
                  hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIP_UPDATE') &&
                  (originalCardStatuses[index] == 'ACTIVE' ||
                    originalChipStatuses[index] == 'OPEN') &&
                  !isEscrow
                "
              >
                <select
                  class="form-control input-sm"
                  [(ngModel)]="chipsAccount[index].status"
                  [name]="'chipStat-' + index"
                  (ngModelChange)="
                    onChangeChip(chipsAccount[index].status, index)
                  "
                >
                  <option
                    *ngFor="let chipStat of chipsAccount[index].targetStats"
                    [value]="chipStat"
                  >
                    {{ chipStat }}
                  </option>
                </select>
              </div>
              <div
                class="form-group col-md-10 staticText1"
                *ngIf="
                  !hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIP_UPDATE') ||
                  (originalCardStatuses[index] != 'ACTIVE' &&
                    originalChipStatuses[index] != 'OPEN') ||
                  isEscrow
                "
              >
                {{ chipsAccount[index].status }}
              </div>
              <div class="col-md-2 float-right" style="margin-top: -40px">
                <p
                  [ngClass]="chipsAccount[index].status | processingStatusPipe"
                ></p>
              </div>
            </div>
          </div>
          <div class="rowThinBorder"></div>
          <div class="row chipRowBackground labelCommon text-nowrap">
            <div
              class="col-md-2 zeroPadding accountBorder"
              *ngIf="
                hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIP_UPDATE') &&
                (originalCardStatuses[index] == 'ACTIVE' ||
                  originalCardStatuses[index] == 'PENDACTIVE') &&
                !isEscrow
              "
            >
              <div class="col-md-12 col-centered">Chip Limit</div>
              <div class="col-md-12">
                <span class="staticText1">
                  <span class="innerFieldSymbol">
                    <i class="fa fa-usd"></i> </span
                  >&nbsp;
                  <input
                    type="text"
                    id="chipLimit"
                    name="chipLimit"
                    [(ngModel)]="cardsAccount[index].chipLimit"
                    [name]="'chipLimit-' + index"
                    (ngModelChange)="
                      onChangeLimit(cardsAccount[index].chipLimit, index)
                    "
                    style="width: 80%"
                    required
                    maxlength="8"
                    class="form-control input-sm outerBox"
                  />
                </span>
              </div>
            </div>
            <div
              class="col-md-2 zeroPadding accountBorder"
              *ngIf="
                !hasEntitlements('CARDHOLDERS_ACCOUNTS_CHIP_UPDATE') ||
                !(
                  originalCardStatuses[index] == 'ACTIVE' ||
                  originalCardStatuses[index] == 'PENDACTIVE'
                ) ||
                isEscrow
              "
            >
              <div class="col-md-12 col-centered">Chip Limit</div>
              <div class="col-md-12 col-centered">
                <span class="staticText1">
                  <span class="dollerSymbolColor">
                    <i class="fa fa-usd"></i> </span
                  >&nbsp;{{ card.chipLimit | currency: "" : "" }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- CHIP ACCOUNT end -->
        <br />
      </div>
    </div>
  </div>
  <div *ngIf="customerAccount.writeOffDate">
    <div id="write-off" class="card card-alert">
      <div class="card-heading wo-card-heading">
        <span class="label">Attention: Automated Balance Write-Off</span>
      </div>
      <div class="card-body">
        <p class="text-justify">
          Due to insufficient funds older than 2 years an automated balance
          write-off has occurred
          {{ customerAccount.writeOffDate | date: "fullDate" }}. Please call
          1-866-3NAVYCASH if you have questions.
        </p>
      </div>
    </div>
  </div>
</form>
<ng-container
  *ngIf="
    hasEntitlements('CARD_ASSIGNMENT_UPDATE') && isSelfEnrolledCardholder()
  "
>
  <form name="assignCardForm" #assignCardForm="ngForm" novalidate>
    <div id="assign-card" class="card card-nc">
      <div class="card-heading">
        <i class="fa fa-credit-card"></i>
        <span class="cardHeaderHeading"> ASSIGN CARD </span>

        <span class="float-right save-card">
          <button
            type="button"
            [ngClass]="{ 'fa fa-spinner': assign_card_btn }"
            *ngIf="
              hasEntitlements('CARDHOLDERS_ACCOUNTS_STRIP_UPDATE') &&
              isEscrow == false
            "
            (click)="assignCard()"
            class="btn btn-nc save-card-btn"
            [disabled]="!assignCardForm.valid"
          >
            ASSIGN
          </button>
        </span>
      </div>
      <div class="card-body">
        <div class="container">
          <div class="row">
            <div class="col-7">
              To assign a card, select a card from the Instant Issue stock,
              enter the card number, and click Assign: <br /><br /><br />
            </div>
            <div class="col-3">
              <input
                class="form-control input-md"
                type="text"
                id="assignCardId"
                name="assignCardId"
                placeholder="Enter MasterCard Number"
                minlength="16"
                maxlength="16"
                [(ngModel)]="assignCardId"
                #cardNumber="ngModel"
                pattern="[0-9]{16}"
                required
              />
              <span
                *ngIf="
                  cardNumber.touched &&
                  cardNumber.dirty &&
                  cardNumber.errors?.pattern
                "
                class="has-error validationMessage"
              >
                16 digit MasterCard number required.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
